class PageHero {
  constructor() {
    if (document.querySelector(".page-hero") && document.querySelector(".page-hero").dataset.heros) {
      this.heros = JSON.parse(document.querySelector(".page-hero").dataset.heros)
      this.heroholder = document.querySelector(".page-hero")
      window.addEventListener("resize", this.resizeHandler.bind(this))
      window.dispatchEvent(new Event("resize"))
    }
  }

  resizeHandler() {
    // 576 is Bootstrap's 'sm' breakpoint value
    const hero = window.innerWidth >= 576 ? this.heros.desktop : this.heros.mobile
    this.heroholder.style.setProperty("--PageHero", hero)
  }
}

export default function init() {
  new PageHero()
}
